"use client";

import React from "react";
import { Button, Tooltip } from "@nextui-org/react";
import { Map, Minus, Plus, WrapText } from "lucide-react";
import { useEditorPrefs } from "@/app/EditorPrefsProvider";

export default function EditorToolbar() {
    const { wordWrap, minimap, fontSize, toggleWordWrap, toggleMinimap, increaseFontSize, decreaseFontSize } =
        useEditorPrefs();

    return (
        <div className="flex items-center gap-1 mb-2" role="group" aria-label="Editor display settings">
            <Tooltip content={wordWrap ? "Disable word wrap" : "Enable word wrap"}>
                <Button
                    isIconOnly
                    size="sm"
                    variant={wordWrap ? "flat" : "light"}
                    color={wordWrap ? "primary" : "default"}
                    radius="sm"
                    aria-pressed={wordWrap}
                    aria-label="Toggle word wrap"
                    onClick={toggleWordWrap}
                >
                    <WrapText className="w-4 h-4" aria-hidden="true" />
                </Button>
            </Tooltip>
            <Tooltip content={minimap ? "Hide minimap" : "Show minimap"}>
                <Button
                    isIconOnly
                    size="sm"
                    variant={minimap ? "flat" : "light"}
                    color={minimap ? "primary" : "default"}
                    radius="sm"
                    aria-pressed={minimap}
                    aria-label="Toggle minimap"
                    onClick={toggleMinimap}
                >
                    <Map className="w-4 h-4" aria-hidden="true" />
                </Button>
            </Tooltip>
            <div className="flex items-center gap-0.5 ml-1">
                <Tooltip content="Decrease font size">
                    <Button
                        isIconOnly
                        size="sm"
                        variant="light"
                        radius="sm"
                        aria-label="Decrease editor font size"
                        onClick={decreaseFontSize}
                    >
                        <Minus className="w-3.5 h-3.5" aria-hidden="true" />
                    </Button>
                </Tooltip>
                <span className="text-xs text-gray-500 dark:text-gray-400 w-6 text-center tabular-nums" aria-live="polite">
                    {fontSize}
                </span>
                <Tooltip content="Increase font size">
                    <Button
                        isIconOnly
                        size="sm"
                        variant="light"
                        radius="sm"
                        aria-label="Increase editor font size"
                        onClick={increaseFontSize}
                    >
                        <Plus className="w-3.5 h-3.5" aria-hidden="true" />
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
}
